import React, { useEffect } from "react";

import { withRouter } from "react-router-dom"
import { connect } from "react-redux"

// import Breadcrumbs from "components/Breadcrumbs";
import Header from "components/Header";
import HeaderUser from "components/HeaderUser";

import Footer from "components/Footer/Footer";

import styles from "./AppLayoutWrapFull.module.scss";

/**
 * Full layout wrapper - with header, navigation, footer.
 * @param {Function} onClick - onClick event handler
 */
const AppLayoutWrapFull = (props) => {
    const { UserOrgSiteReducer, setActiveTab } = props;
    useEffect(() => {
        document.body.classList.add('app-layout-full');
        return () => {
            document.body.classList.remove('app-layout-full');
        };
    });
    return (
        <div className={styles.holder} onClick={props.onClick}>
            <div>
                {UserOrgSiteReducer && UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin
                    ? <Header />
                    : <HeaderUser setActiveTab={setActiveTab} />
                }
            </div>
            <div>{props.children}</div>
            <Footer />
        </div>
    );

}

const mapStateToProps = (state) => ({
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(AppLayoutWrapFull)
);
